import * as yup from "yup";
import {
  validateDate,
  validateTime,
  validateTimeNotInFuture,
} from "../datetime";
import { VALID_DATE } from "@common/constants/validation";

// Define the validation schema using yup
export const observationsSchema = yup
  .object()
  .shape({
    observationDate: VALID_DATE,
    observationTime: yup
      .string()
      .required("Time is required")
      .test("not-in-future", "Time cannot be in the future", function (time) {
        const { observationDate } = this.parent;
        return validateTimeNotInFuture(time, observationDate);
      }),

    customerUnknown: yup.boolean(),
    observation: yup.object().shape({
      id: yup.number().positive().min(1, "ID type is required."),
      name: yup.string(),
      detailsRequired: yup.boolean(),
    }),
    customerMood: yup.array().required("Please select a mood option"),
    comments: yup.string().notRequired(),

    setReminder: yup
      .boolean()
      .required("Please choose whether to set a reminder or not."),

    reminderDate: yup.string().when("setReminder", {
      is: true,
      then: (schema) =>
        schema
          .required("Date is required")
          .test("is-valid-date", "Reminder date is not valid", validateDate),
      otherwise: (schema) => schema.notRequired(),
    }),
    reminderTime: yup.string().when("setReminder", {
      is: true,
      then: (schema) =>
        schema
          .required("Time is required")
          .test("is-valid-time", "Reminder time is not valid", validateTime),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
  .test(
    "one-of-two",
    "Either customer or customerId must be provided",
    function (value) {
      return value.customer || value.customerId;
    },
  );
